import * as yup from 'yup';
import { EMAIL, PASSWORD } from 'src/utils/validation/validationRules';
import { validationErrors } from 'src/utils/validation/validationErrors';

export const loginFormValidationSchema = yup.object().shape({
  email: EMAIL.required(validationErrors.REQUIRED_FIELD),
  password: PASSWORD.required(validationErrors.REQUIRED_FIELD),
});
